var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"layer1-2","transform":"matrix(0.480185, 0, 0, 0.480185, -316.231, 468.11)"},React.createElement("path",{"fill":"#000000","stroke":"#000000","strokeWidth":"19.891832","strokeMiterlimit":"4","id":"path4068","d":"m668.512207,-464.059631l287.721191,333.89859c146.600952,-298.83078 326.061523,-573.743256 614.515503,-834.746552c-215.88562,121.817505 -453.859253,353.141724 -657.140869,639.380341l-245.095825,-138.532379z"})));
}

Checkmark.defaultProps = {"viewBox":"0 0 442.79211 410.38434"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
